module.exports = __webpack_public_path__ + "static/media/loading.c5590569.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/loading.svg
// module id = 484
// module chunks = 0